import { render, staticRenderFns } from "./crew.vue?vue&type=template&id=1baeca42&scoped=true&"
import script from "./crew.vue?vue&type=script&lang=js&"
export * from "./crew.vue?vue&type=script&lang=js&"
import style0 from "./crew.vue?vue&type=style&index=0&id=1baeca42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baeca42",
  null
  
)

export default component.exports